import { type FC } from 'react';
import { lightTheme } from '~/_shared/themes/light.theme';
import { BrandedAuthPageLayoutComponent } from '~/authentication/pageWrapper/brandedAuthPageLayoutComponent';
import { RegisterFormContainer } from './form/registerForm.container';
import { RegisterMarketingPanelComponent } from './marketing/registerMarketingPanel.component';

export const RegisterPageComponent: FC = () => {
  return (
    <BrandedAuthPageLayoutComponent
      dimHeroBackground
      heroContent={<RegisterMarketingPanelComponent />}
      theme={lightTheme}
    >
      <RegisterFormContainer />
    </BrandedAuthPageLayoutComponent>
  );
};
